import { defineStore } from "pinia";
import { LoginHttp } from "@/models/interfaces/http/login.http.request";
import { LoginAsker, LoginGiver, RecoverAsker} from "@/models/login/login";

const API_URL = process.env.VUE_APP_API_URL

export type LoginState = {
  currentUserId: number | null;
  sessionKey: string | null;
  jwtToken: string | null;
  refreshUser: boolean;
  currentWorker: any;
  isLoading: boolean;
  loginError: string | null;
  statusCode: number | null;
};

export const authStore = defineStore("authStore", {
  state: () => ({
    currentUserId: null,
    sessionKey: null,
    jwtToken: null,
    refreshUser: false,
    currentWorker: null,
    isLoading: false,
    loginError: null,
    statusCode: null
  } as LoginState),

  actions: {
    setUserId(id: number) {
      this.currentUserId = id;
    },

    setSessionKey(key: string) {
      this.sessionKey = key;
    },

    setJWT(jwt: string) {
      this.jwtToken = jwt;
    },

    setRefreshUser(value: boolean) {
      this.refreshUser = value;
    },

    setCurrentWorker(worker: any) {
      this.currentWorker = worker;
    },

    async LoginAuth(body: LoginAsker) {
      const http = new LoginHttp(API_URL)
      try {
        this.isLoading = true;
        this.loginError = null;
        this.statusCode = null;

        const response  = await http.post('login', body);
        if (response.status === 200) {

          const data: LoginGiver = response.data;
          this.setUserId(data.UserId);
          this.setSessionKey(data.SessionKey);
          this.setJWT(data.UserAuthToken);
          localStorage.setItem("currentSession", JSON.stringify({
            id: data.UserId,
            sessionKey: data.SessionKey,
            jwtToken: data.UserAuthToken
          }));

          return true;
        }
        else {
          // @ts-ignore
          this.loginError = response.response.data.Message;
          this.statusCode = response.status;
        }
      } catch (e) {
        console.log(JSON.stringify(e))
      } finally {
        this.isLoading = false;
      }
    },

    async recoverByEmail(body: RecoverAsker) {
      const http = new LoginHttp(API_URL)
      try {
        this.isLoading = true;
        this.loginError = null;
        this.statusCode = null;

        // @ts-ignore
        const  response  = await http.post('recover/mail', body);

        if (response.status === 200) {
          return true;
        } else {
          // @ts-ignore
          this.loginError = response.response.data.Message;
          this.statusCode = response.status;
        }

      } catch (e) {
        console.log(JSON.stringify(e))
      } finally {
        this.isLoading = false;
      }
    },

    async recoverByName(body: RecoverAsker) {
      const http = new LoginHttp(API_URL)
      try {
        this.isLoading = true;
        this.loginError = null;
        this.statusCode = null;

        // @ts-ignore
        const  response  = await http.post('recover/name', body);

        if (response.status === 200) {
          return true;
        } else {
          // @ts-ignore
          this.loginError = response.response.data.Message;
          this.statusCode = response.status;
        }
      } catch (e) {
        console.log(JSON.stringify(e))
      } finally {
        this.isLoading = false;
      }
    },

    clearErrorMessage(): void {
      this.loginError = null;
    }
  },

  getters: {
    getCurrentUserId: (state) => state.currentUserId,
    getSessionKey: (state) => state.sessionKey,
    getJWT: (state) => state.jwtToken,
    getCurrentWorker: (state) => state.currentWorker,
    loginIsLoading: (state) => state.isLoading,
    ErrorMessage: (state) => state.loginError
  },
});